import ActionType from '../../actions/ActionType'
import { REQUEST, SUCCESS, FAILURE } from '../../utils/statusConstants'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Contacts.GET_ALL_GROUPS_REQUEST:
      return REQUEST
    case ActionType.Contacts.GET_ALL_GROUPS_SUCCESS:
      return SUCCESS
    case ActionType.Contacts.GET_ALL_GROUPS_FAILURE:
      return FAILURE
    default:
      return state
  }
}
